<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-calculator" titulo="CADASTRO DE TEMPLATE DE CUSTO">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{ registro.ID || 'Novo' }}</strong>
            </span>
            <span v-if="registro.DESCRICAO" class="text-white-50">{{ registro.DESCRICAO }}</span>
          </div>
        </template>
        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" :disabled="isBusy" @click.stop.prevent="gravar">
            <i class="fa fa-save mr-1"></i> {{ registro.ID ? 'SALVAR' : 'GRAVAR' }}
          </b-button>
          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- MASTER -->
          <b-card class="shadow-sm mb-3" :class="{'bg-dark border-secondary': isDark}">
            <b-row>
              <b-col md="2">
                <label class="modal-label-premium">ID</label>
                <b-form-input :value="registro.ID || 'Novo'" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado text-center font-weight-bold"></b-form-input>
              </b-col>
              <b-col md="10">
                <label class="modal-label-premium">Descrição do Template *</label>
                <b-form-input v-model="registro.DESCRICAO" maxlength="100" class="rounded-pill shadow-xs" :class="{'is-invalid': !registro.DESCRICAO}"></b-form-input>
              </b-col>
            </b-row>
          </b-card>

          <!-- DETAILS -->
          <b-card class="shadow-sm mb-3" :class="{'bg-dark border-secondary': isDark}">
            <template #header>
              <div class="d-flex justify-content-between align-items-center">
                <h6 class="mb-0 font-weight-bold"><i class="fa fa-list mr-2"></i>Itens do Template</h6>
                <b-button size="sm" variant="primary" pill @click="abrirModalItem()" class="px-3 shadow-sm font-weight-bold" :disabled="!registro.ID">
                  <i class="fa fa-plus mr-1"></i> Adicionar Item
                </b-button>
              </div>
            </template>
            
            <b-alert v-if="!registro.ID" show variant="warning" class="mb-3">
              Grave o cabeçalho do template para liberar a inclusão dos itens.
            </b-alert>
            
            <b-table
              v-if="registro.ID"
              class="mb-0 table-finance"
              show-empty
              empty-text="Nenhum item adicionado ao template"
              responsive
              hover
              small
              :items="registro.ITENS"
              :fields="colunasDetalhe"
              :dark="isDark"
            >
              <template #cell(TIPO_ITEM)="ctx">
                 <b-badge :variant="ctx.item.TIPO_ITEM === 'P' ? 'info' : 'secondary'">{{ ctx.item.TIPO_ITEM === 'P' ? 'Produto' : 'Manual' }}</b-badge>
              </template>
              <template #cell(DESCRICAO_EXIBICAO)="ctx">
                 <div v-if="ctx.item.TIPO_ITEM === 'P'">
                    <span class="d-block font-weight-bold text-primary">{{ ctx.item.PRODUTO_DESCRICAO || 'Produto selecionado' }}</span>
                    <small class="text-muted" v-if="ctx.item.DESCRICAO">{{ ctx.item.DESCRICAO }}</small>
                 </div>
                 <div v-else>
                    {{ ctx.item.DESCRICAO || '-' }}
                 </div>
              </template>
              <template #cell(NATUREZA_ID)="ctx">
                 {{ obterNomeNatureza(ctx.item.NATUREZA_ID) }}
              </template>
              <template #cell(VALOR)="ctx">
                {{ formatarValor(ctx.item.VALOR) }}
              </template>
              <template #cell(QTDE)="ctx">
                {{ formatarQtde(ctx.item.QTDE) }}
              </template>
              <template #cell(UNITARIO)="ctx">
                {{ formatarValor(ctx.item.UNITARIO) }}
              </template>
              <template #cell(TOTAL)="ctx">
                <strong>{{ formatarValor((ctx.item.VALOR || 0) + ((ctx.item.QTDE || 0) * (ctx.item.UNITARIO || 0))) }}</strong>
              </template>
              <template #cell(actions)="ctx">
                <div class="d-flex justify-content-center gap-1">
                  <b-button size="sm" @click.stop.prevent="editarItem(ctx.item, ctx.index)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar">
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button size="sm" @click.stop.prevent="removerItem(ctx.index)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Remover">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>
              <template #custom-foot="{ fields }">
                <b-tr>
                  <b-td :colspan="fields.length - 2" class="text-right bg-light py-2 px-3 font-weight-bold">Total do Template:</b-td>
                  <b-td colspan="2" class="text-left bg-light py-2 px-3 text-primary font-weight-bold" style="font-size: 1rem;">
                    {{ formatarValor(totalTemplate) }}
                  </b-td>
                </b-tr>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>

      <!-- Modal Add/Edit Item -->
      <b-modal 
        id="modalItem" 
        header-class="p-0"
        no-close-on-esc
        no-close-on-backdrop
        centered
        body-class="p-0"
        size="lg"
        modal-class="premium-modal">
        <template #modal-header>
          <div class="bg-gradient-success w-100 p-3 d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="bg-white-20 rounded-circle p-2 mr-3">
                <i class="fa fa-calculator text-white"></i>
              </div>
              <div>
                <h5 class="mb-0 font-weight-bold text-white">{{ indexEdicao >= 0 ? 'Editar Item' : 'Novo Item' }}</h5>
                <small class="text-white-50">Confirmar salva automaticamente no banco</small>
              </div>
            </div>
            <button type="button" class="close text-white" :disabled="isBusyModal" @click="$bvModal.hide('modalItem')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>

        <b-card no-body class="border-0">
          <div class="p-4 bg-white">
            <b-row>
              <b-col md="12" class="mb-3">
                <label class="modal-label-premium">Tipo de Custo</label>
                <b-form-radio-group
                  v-model="itemEdicao.TIPO_ITEM"
                  :options="[{text: 'Manual (Despesa Padrão)', value: 'M'}, {text: 'Produto (Insumo / Terceirização)', value: 'P'}]"
                  buttons
                  button-variant="outline-primary"
                  size="sm"
                  class="w-100"
                ></b-form-radio-group>
              </b-col>
            </b-row>
            <b-row v-if="itemEdicao.TIPO_ITEM === 'P'">
              <b-col md="12" class="mb-3">
                 <bens-pesquisa 
                   label="Produto Vinculado *" 
                   place="Buscar produto..."
                   labelBotao="Buscar"
                   :idInicial="itemEdicao.PRODUTO_ID"
                   :classeRequired="modalEnviado && !itemEdicao.PRODUTO_ID"
                   @retornaId="itemEdicao.PRODUTO_ID = $event"
                   @retornaNome="itemEdicao.PRODUTO_DESCRICAO = $event"
                   @retornaCusto="itemEdicao.UNITARIO = $event || 0">
                 </bens-pesquisa>
                 <div v-if="modalEnviado && !itemEdicao.PRODUTO_ID" class="text-danger small mt-1">O produto é obrigatório.</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mb-3">
                <label class="modal-label-premium">Natureza de Custo *</label>
                <b-form-select v-model="itemEdicao.NATUREZA_ID" :options="opcoesNatureza" class="rounded-pill shadow-xs form-control" :class="{'is-invalid': modalEnviado && !itemEdicao.NATUREZA_ID}"></b-form-select>
                <b-form-invalid-feedback>A natureza é obrigatória.</b-form-invalid-feedback>
              </b-col>
              <b-col md="6" class="mb-3">
                 <label class="modal-label-premium">Descrição Complementar</label>
                 <b-form-input v-model="itemEdicao.DESCRICAO" maxlength="100" class="rounded-pill shadow-xs" placeholder="Ex: Energia Setor B"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="mb-3">
                <label class="modal-label-premium">Valor Fixo (R$)</label>
                <vue-autonumeric v-model="itemEdicao.VALOR" :options="formatoMoeda" class="form-control rounded-pill shadow-xs text-right"></vue-autonumeric>
              </b-col>
              <b-col md="4" class="mb-3">
                <label class="modal-label-premium">Quantidade (Horas/Unid)</label>
                <vue-autonumeric v-model="itemEdicao.QTDE" :options="formatoQtde" class="form-control rounded-pill shadow-xs text-right"></vue-autonumeric>
              </b-col>
              <b-col md="4" class="mb-3">
                 <label class="modal-label-premium">Valor Unitário (R$)</label>
                 <vue-autonumeric v-model="itemEdicao.UNITARIO" :options="formatoMoeda" class="form-control rounded-pill shadow-xs text-right"></vue-autonumeric>
              </b-col>
            </b-row>
          </div>
        </b-card>
        
        <template #modal-footer>
          <b-button variant="light" pill class="px-4 shadow-sm" :disabled="isBusyModal" @click="$bvModal.hide('modalItem')">CANCELAR</b-button>
          <b-button variant="success" pill class="px-4 shadow-sm font-weight-bold" :disabled="isBusyModal" @click="salvarItemModal">
            <b-spinner small v-if="isBusyModal" class="mr-1"></b-spinner>
            <i class="fa fa-check mr-1" v-else></i>
            {{ isBusyModal ? 'SALVANDO...' : 'CONFIRMAR E SALVAR' }}
          </b-button>
        </template>
      </b-modal>

    </div>
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import VueAutonumeric from 'vue-autonumeric'
import BensPesquisa from '@/views/pesquisa/BensPesquisa.vue'
import Tools from '@/tools/tools.js'

export default {
  components: {
    HeaderPadrao,
    VueAutonumeric,
    BensPesquisa
  },
  data() {
    return {
      isBusy: false,
      isBusyModal: false,
      registro: {
        ID: null,
        DESCRICAO: '',
        ITENS: []
      },
      colunasDetalhe: [
        { key: 'TIPO_ITEM', label: 'Tipo', class: 'align-middle font-weight-bold text-center', thStyle: { width: '8%' } },
        { key: 'NATUREZA_ID', label: 'Natureza', class: 'align-middle font-weight-bold', thStyle: { width: '17%' } },
        { key: 'DESCRICAO_EXIBICAO', label: 'Detalhes / Produto', class: 'align-middle', thStyle: { width: '25%' } },
        { key: 'VALOR', label: 'Vlr Fixo', class: 'align-middle text-right', thStyle: { width: '10%' } },
        { key: 'QTDE', label: 'Qtde', class: 'align-middle text-right', thStyle: { width: '10%' } },
        { key: 'UNITARIO', label: 'Vlr Unit', class: 'align-middle text-right', thStyle: { width: '10%' } },
        { key: 'TOTAL', label: 'Total', class: 'align-middle text-right text-primary font-weight-bold', thStyle: { width: '10%' } },
        { key: 'actions', label: 'Ações', class: 'align-middle text-center', thStyle: { width: '10%' } }
      ],
      opcoesNatureza: [],
      itemEdicao: {},
      indexEdicao: -1,
      modalEnviado: false,
      formatoMoeda: {
        decimalCharacter: ',',
        digitGroupSeparator: '.',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        decimalPlaces: '2',
        minimumValue: '0'
      },
      formatoQtde: {
        decimalCharacter: ',',
        digitGroupSeparator: '.',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        decimalPlaces: '3',
        minimumValue: '0'
      }
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    totalTemplate() {
      return (this.registro.ITENS || []).reduce((acc, it) => {
        return acc + (Number(it.VALOR)||0) + ((Number(it.QTDE)||0) * (Number(it.UNITARIO)||0));
      }, 0);
    }
  },
  methods: {
    formatarValor(v) { return Tools.formatCurrency(v || 0); },
    formatarQtde(v) { return Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }); },
    voltar() {
      this.$router.push('/cadastros/custo-operacional/listagem')
    },
    async carregarCombos() {
      try {
        const response = await this.$http.get('/api/protected/natureza-custo/getListaLocaliza')
        if (response.data) {
           this.opcoesNatureza = [{ value: null, text: 'Selecione uma natureza' }, ...response.data.map(n => ({ value: n.ID, text: n.DESCRICAO }))]
        }
      } catch (err) {
        console.error("Erro ao carregar naturezas", err)
      }
    },
    obterNomeNatureza(id) {
       if (id == null) return '-';
       const nat = this.opcoesNatureza.find(x => String(x.value) === String(id));
       return nat ? nat.text : '-';
    },
    abrirModalItem() {
      this.modalEnviado = false;
      this.indexEdicao = -1;
      this.itemEdicao = {
        TIPO_ITEM: 'M',
        PRODUTO_ID: null,
        PRODUTO_DESCRICAO: '',
        NATUREZA_ID: null,
        DESCRICAO: '',
        VALOR: 0,
        QTDE: 0,
        UNITARIO: 0
      };
      this.$bvModal.show('modalItem');
    },
    editarItem(item, index) {
      this.modalEnviado = false;
      this.indexEdicao = index;
      this.itemEdicao = { ...item };
      this.$bvModal.show('modalItem');
    },
    removerItem(index) {
      this.$bvModal.msgBoxConfirm('Remover este item do template?', {
        title: 'Confirmar Exclusão',
        okVariant: 'danger',
        okTitle: 'Remover',
        cancelTitle: 'Cancelar',
        centered: true
      }).then(async (confirm) => {
        if (!confirm) return;
        this.registro.ITENS.splice(index, 1);
        await this.persistirItens();
      });
    },
    async persistirItens() {
      // Persiste o estado atual dos itens no banco sem recarregar a tela
      try {
        await this.$http.post('/api/protected/custo-operacional/edit', {
          ID: this.registro.ID,
          DESCRICAO: this.registro.DESCRICAO,
          ITENS: this.registro.ITENS
        });
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message || 'Erro ao salvar itens');
        throw err;
      }
    },
    async salvarItemModal() {
      this.modalEnviado = true;
      if (!this.itemEdicao.NATUREZA_ID) return;
      if (this.itemEdicao.TIPO_ITEM === 'P' && !this.itemEdicao.PRODUTO_ID) return;
      
      const clone = { ...this.itemEdicao };
      if (!this.registro.ITENS) this.$set(this.registro, 'ITENS', []);

      // Monta o array temporário com a alteração
      const itensAtualizados = [...this.registro.ITENS];
      if (this.indexEdicao >= 0) {
        itensAtualizados[this.indexEdicao] = clone;
      } else {
        itensAtualizados.push(clone);
      }

      this.isBusyModal = true;
      try {
        // Persiste imediatamente no banco antes de fechar o modal
        await this.$http.post('/api/protected/custo-operacional/edit', {
          ID: this.registro.ID,
          DESCRICAO: this.registro.DESCRICAO,
          ITENS: itensAtualizados
        });

        // Recarrega do banco para ter os IDs reais dos itens
        await this.carregarRegistro(this.registro.ID);
        this.$bvModal.hide('modalItem');
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message || 'Erro ao salvar item');
      } finally {
        this.isBusyModal = false;
      }
    },
    async carregarRegistro(id) {
      this.isBusy = true
      try {
        const response = await this.$http.get(`/api/protected/custo-operacional/getById/${id}`)
        if (response.data) {
          if (!response.data.ITENS) response.data.ITENS = [];
          this.registro = response.data
        } else {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Registro não encontrado')
          this.voltar()
        }
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message || 'Erro inesperado')
      } finally {
        this.isBusy = false
      }
    },
    async gravar() {
      if (!this.registro.DESCRICAO) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'A descrição do template é obrigatória.')
        return
      }
      
      if (this.registro.ID && (!this.registro.ITENS || this.registro.ITENS.length === 0)) {
         Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Adicione pelo menos um item ao template.')
         return
      }

      this.isBusy = true
      try {
        const url = this.registro.ID ? '/api/protected/custo-operacional/edit' : '/api/protected/custo-operacional/post'
        const response = await this.$http.post(url, this.registro)
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Template gravado com sucesso!')
        
        if (!this.registro.ID && response.data && response.data.ID) {
           this.registro.ID = response.data.ID;
           this.$router.replace(`/cadastros/custo-operacional/editar/${this.registro.ID}`).catch(() => {});
        }
        await this.carregarRegistro(this.registro.ID);
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', err.response?.data || err.message || 'Erro inesperado')
      } finally {
        this.isBusy = false
      }
    }
  },
  async mounted() {
    await this.carregarCombos();
    if (this.$route.params.id) {
      await this.carregarRegistro(this.$route.params.id)
    }
  }
}
</script>

<style scoped>
.list-header-premium { background: #fff; border-bottom: 1px solid #e2e8f0; }
.header-icon-wrapper { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; border-radius: 12px; box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); }
.header-icon-wrapper i { font-size: 1.5rem; }
.modal-label-premium { font-size: 0.8rem; font-weight: 600; color: #475569; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.5rem; display: block; }
.campo-desabilitado { background-color: #f8fafc !important; color: #64748b; cursor: not-allowed; border-color: #e2e8f0; }

.shadow-xs { box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); }
.btn-glass { border: none; font-weight: 600; transition: all 0.3s ease; text-transform: uppercase; letter-spacing: 0.05em; }
.btn-glass-success { background: rgba(34, 197, 94, 0.1); color: #16a34a; }
.btn-glass-success:hover:not(:disabled) { background: rgba(34, 197, 94, 0.2); color: #15803d; }
.btn-glass-success:disabled { opacity: 0.6; cursor: not-allowed; }

.table-finance { font-size: 0.8rem !important; }
.table-finance >>> thead th { background-color: #f8fafc !important; text-transform: uppercase; font-size: 0.7rem !important; letter-spacing: 0.05em; color: #64748b; border-top: none; border-bottom: 2px solid #e2e8f0 !important; padding: 0.4rem 0.75rem !important; position: sticky !important; top: 0; z-index: 20 !important; }
.table-finance >>> tbody td { padding: 0.2rem 0.75rem !important; vertical-align: middle; border-bottom: 1px solid #f1f5f9; }
.btn-icon-only { width: 32px; height: 32px; padding: 0; display: inline-flex; align-items: center; justify-content: center; }
.btn-soft-primary { background: #eff6ff; color: #3b82f6; border: none; }
.btn-soft-primary:hover { background: #dbeafe; color: #2563eb; }
.btn-soft-danger { background: #fef2f2; color: #ef4444; border: none; }
.btn-soft-danger:hover { background: #fee2e2; color: #dc2626; }

@media (max-width: 767px) {
  .list-header-premium { gap: 0.5rem !important; padding-bottom: 1rem !important; }
  .list-header-premium .p-3 { padding: 0.75rem !important; }
}
</style>



// WEBPACK FOOTER //
// src/views/cadastros/custo-operacional/CentroCustoOpCadastro.vue